/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseDashboardInfoDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListPlatformGroupDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListRecentDeviceWithLeakDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListRecentUserDTO } from '../backend/model';
/**
 * CouncilDashboardApi - axios parameter creator
 * @export
 */
export const CouncilDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get dashboard data for a specific council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilDashboard: async (councilId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilDashboard', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/dashboard`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get recent devices with leaks for a specific council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDevicesWithLeaks: async (councilId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getRecentDevicesWithLeaks', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/dashboard/recent-devices-with-leaks`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get recent users for a specific council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentUsers: async (councilId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getRecentUsers', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/dashboard/recent-users`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get user count by platform groups for a specific council
         * @param {number} councilId 
         * @param {Array<string>} group 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCountByPlatformGroups: async (councilId: number, group: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getUserCountByPlatformGroups', 'councilId', councilId)
            // verify required parameter 'group' is not null or undefined
            assertParamExists('getUserCountByPlatformGroups', 'group', group)
            const localVarPath = `/api/council/{councilId}/dashboard/user-count-by-platform-groups`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (group) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouncilDashboardApi - functional programming interface
 * @export
 */
export const CouncilDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouncilDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get dashboard data for a specific council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilDashboard(councilId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDashboardInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilDashboard(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDashboardApi.getCouncilDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get recent devices with leaks for a specific council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentDevicesWithLeaks(councilId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListRecentDeviceWithLeakDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentDevicesWithLeaks(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDashboardApi.getRecentDevicesWithLeaks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get recent users for a specific council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentUsers(councilId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListRecentUserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentUsers(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDashboardApi.getRecentUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get user count by platform groups for a specific council
         * @param {number} councilId 
         * @param {Array<string>} group 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCountByPlatformGroups(councilId: number, group: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListPlatformGroupDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCountByPlatformGroups(councilId, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDashboardApi.getUserCountByPlatformGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouncilDashboardApi - factory interface
 * @export
 */
export const CouncilDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouncilDashboardApiFp(configuration)
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get dashboard data for a specific council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilDashboard(councilId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDashboardInfoDTO> {
            return localVarFp.getCouncilDashboard(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get recent devices with leaks for a specific council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDevicesWithLeaks(councilId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListRecentDeviceWithLeakDTO> {
            return localVarFp.getRecentDevicesWithLeaks(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get recent users for a specific council
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentUsers(councilId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListRecentUserDTO> {
            return localVarFp.getRecentUsers(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get user count by platform groups for a specific council
         * @param {number} councilId 
         * @param {Array<string>} group 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCountByPlatformGroups(councilId: number, group: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListPlatformGroupDTO> {
            return localVarFp.getUserCountByPlatformGroups(councilId, group, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouncilDashboardApi - object-oriented interface
 * @export
 * @class CouncilDashboardApi
 * @extends {BaseAPI}
 */
export class CouncilDashboardApi extends BaseAPI {
    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get dashboard data for a specific council
     * @param {number} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDashboardApi
     */
    public getCouncilDashboard(councilId: number, options?: RawAxiosRequestConfig) {
        return CouncilDashboardApiFp(this.configuration).getCouncilDashboard(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get recent devices with leaks for a specific council
     * @param {number} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDashboardApi
     */
    public getRecentDevicesWithLeaks(councilId: number, options?: RawAxiosRequestConfig) {
        return CouncilDashboardApiFp(this.configuration).getRecentDevicesWithLeaks(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get recent users for a specific council
     * @param {number} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDashboardApi
     */
    public getRecentUsers(councilId: number, options?: RawAxiosRequestConfig) {
        return CouncilDashboardApiFp(this.configuration).getRecentUsers(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get user count by platform groups for a specific council
     * @param {number} councilId 
     * @param {Array<string>} group 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDashboardApi
     */
    public getUserCountByPlatformGroups(councilId: number, group: Array<string>, options?: RawAxiosRequestConfig) {
        return CouncilDashboardApiFp(this.configuration).getUserCountByPlatformGroups(councilId, group, options).then((request) => request(this.axios, this.basePath));
    }
}

